import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import GroupCalonNasabah from "./groupCalonNasabah";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { Dna } from "react-loader-spinner";
import { getAllCalonNasabah } from "stores";
import { editNikCalonNasabah } from "stores";

function CalonNasabah() {
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  const auth = useSelector((state) => state.authReducer);

  //   console.log(korcab, "KORCAB");
  const [listDataCalonNasabah, setListDataCalonNasabah] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [idCalonNasabah, setIdCalonNasabah] = React.useState("");
  const [sendVal, setSendVal] = React.useState("");
  const [modalEditNik, setModalEditNik] = React.useState(false);
  const [nik, setNik] = React.useState("");
  const [remainingDigits, setRemainingDigits] = React.useState(16);

  const handleNikChange = (e) => {
    const value = e.target.value;

    const numericValue = value.replace(/[^0-9]/g, "");

    if (numericValue.length <= 16) {
      setNik(numericValue);
      setRemainingDigits(16 - numericValue.length);
    }
  };
  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    setPage(0);
    getAllCalonNasabah(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_NASABAH", data: false });
    setIdCalonNasabah(val._id);
    setSendVal(val);
    // dispatch({ type: "SET_KIRIM_DETAIL_NASABAH", data: val });
  };

  const submitUpdateNik = async () => {
    if (nik.length !== 16) {
      Swal.fire({
        title: "Perhatian",
        text: "Nomor Induk Kependudukan (NIK) harus tepat 16 digit angka!",
        icon: "warning",
        confirmButtonColor: "#b42323",
      });
      return;
    }

    try {
      const response = await editNikCalonNasabah({
        idCalonNasabah: idCalonNasabah,
        nik: nik,
      });

      if (response && (response.status === 200 || response.status === 201)) {
        Swal.fire({
          title: "Sukses",
          text:
            response.data?.message || "NIK Calon Nasabah berhasil diperbarui!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });

        setModalEditNik(false);

        getAllCalonNasabah(dispatch, {
          page: page + 1,
          limit: totalPerHalaman,
          cari: searchText,
        });
      } else {
        Swal.fire({
          title: "Gagal Mengubah NIK",
          text:
            response.data?.message ||
            "Terjadi kesalahan pada sistem penandatanganan berkas.",
          icon: "error",
          confirmButtonColor: "#EF4444",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Tidak dapat terhubung ke server. Silakan coba beberapa saat lagi.",
        icon: "error",
        confirmButtonColor: "#EF4444",
      });
    }
  };

  React.useEffect(() => {
    let tmp =
      korcab.listCalonNasabah.docs &&
      korcab.listCalonNasabah.docs.map((val) => {
        return {
          ...val,
          action: (
            <>
              {/* Kapsul Utama Pengapit Tombol Aksi Horizontal Premium */}
              <div
                className="d-inline-flex align-items-center"
                style={{
                  backgroundColor: "#F1F5F9",
                  border: "1px solid #E2E8F0",
                  padding: "4px 8px",
                  borderRadius: "30px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  verticalAlign: "middle",
                  gap: "2px",
                }}
              >
                {/* TOMBOL 1: DETAILS NASABAH */}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-details-${val._id}`}>
                      Details Nasabah
                    </Tooltip>
                  }
                >
                  <Button
                    variant="link"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "32px",
                      height: "32px",
                      padding: 0,
                      borderRadius: "50%",
                      color: "#F43F5E" /* Rose Crimson */,
                      backgroundColor: "transparent",
                      border: "none",
                      transition: "all 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#FFE4E6";
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    onClick={() => {
                      handleDetailsClick(val);
                    }}
                  >
                    <i
                      className="fas fa-search-plus"
                      style={{ fontSize: "13px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>

                <span
                  style={{
                    width: "1px",
                    height: "14px",
                    backgroundColor: "#CBD5E1",
                    margin: "0 4px",
                  }}
                />
                {auth.role === "super admin" ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-edit-nik-${val._id}`}>
                        Edit NIK Nasabah
                      </Tooltip>
                    }
                  >
                    <Button
                      variant="link"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "32px",
                        height: "32px",
                        padding: 0,
                        borderRadius: "50%",
                        color: "#F59E0B" /* Amber/Gold fintech modern */,
                        backgroundColor: "transparent",
                        border: "none",
                        transition: "all 0.2s ease",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#FEF3C7";
                        e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                      onClick={() => {
                        setIdCalonNasabah(val._id); // Simpan ID terpilih ke state Anda
                        setNik(val.nik || ""); // Set default value NIK lama ke form
                        setModalEditNik(!modalEditNik); // Trigger buka modal
                      }}
                    >
                      <i
                        className="fas fa-id-card"
                        style={{ fontSize: "13px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>
                ) : null}
              </div>
            </>
          ),
        };
      });
    setListDataCalonNasabah(tmp);
  }, [korcab.listCalonNasabah, auth]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getTypeKunjungan = (status) => {
    switch (status) {
      case "Dinas":
        return {
          fontWeight: "bold",
          backgroundColor: "#DDF3F4",
          textColor: "#0C8990",
        };
      case "Personal":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFF6E6",
          textColor: "#FFA700",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9",
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start", // Lurus kiri
      },
    },
    rows: {
      style: {
        minHeight: "65px",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Lurus kiri
      },
    },
  };

  const colKunjungan = [
    {
      name: "NO",
      width: "100px",
      center: false,
      cell: (row, index) => (
        <span className="fw-800 text-muted " style={{ fontSize: "14px" }}>
          {index + korcab.listCalonNasabah.pagingCounter}
        </span>
      ),
    },
    {
      name: "NAMA NASABAH",
      minWidth: "290px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <span
            className="fw-900 text-dark d-block"
            style={{ fontSize: "15px" }}
          >
            {row.namaNasabah}
          </span>
          <span className="text-muted fw-600" style={{ fontSize: "12px" }}>
            HP: {row.noHp}
          </span>
        </div>
      ),
    },
    {
      name: "IDENTITAS (NIP/NIK)",
      minWidth: "220px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <div className="fw-800 text-dark" style={{ fontSize: "13px" }}>
            NIP: {!row.nip ? "-" : row.nip}
          </div>
          <div className="text-muted fw-600" style={{ fontSize: "13px" }}>
            NIK: {!row.nik ? "-" : row.nik}
          </div>
        </div>
      ),
    },
    {
      name: "TGL LAHIR",
      minWidth: "190px",
      center: false,
      cell: (row) => (
        <span className="fw-700 text-dark ml-1">
          <i className="far fa-calendar-alt mr-2 text-primary"></i>
          {moment(row.tglLahir).format("DD MMM YYYY")}
        </span>
      ),
    },
    {
      name: "MARKETING ON GOING",
      minWidth: "290px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <div className="fw-800 text-primary" style={{ fontSize: "14px" }}>
            {!row.marketing ? "-" : row.marketing.nama}
          </div>
          <div className="small text-muted fw-600">
            NOPEG: {!row.marketing ? "-" : row.marketing.nopeg}
          </div>
        </div>
      ),
    },
    {
      name: "KATEGORI",
      minWidth: "250px",
      center: false,
      cell: (row) => {
        const kategori =
          row.kategoriNasabah === "1"
            ? "PNS Biasa"
            : row.kategoriNasabah === "2"
              ? "PNS Prapurna Bakti"
              : row.kategoriNasabah === "3"
                ? "Pensiunan"
                : row.kategoriNasabah === "4"
                  ? "PRA THT"
                  : "KPS (Kredit Pensiunan)";
        return (
          <span className="badge badge-light border px-3 py-2 fw-700 ml-1">
            {kategori}
          </span>
        );
      },
    },
    {
      name: "TIPE KUNJUNGAN",
      minWidth: "220px",
      center: false,
      cell: (row) => {
        const statusStyle = getTypeKunjungan(row.typeKunjungan);
        return (
          <div
            className="ml-1 shadow-sm d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "800",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "8px 15px",
              borderRadius: "50px", // Style Pill/Oval
              fontSize: "12px",
              minWidth: "120px",
              textTransform: "uppercase",
            }}
          >
            <i className="fas fa-info-circle mr-2"></i>
            {row.typeKunjungan}
          </div>
        );
      },
    },
    {
      name: "AKSI",
      minWidth: "150px",
      center: true, // Aksi biarkan center agar balance di ujung
      cell: (row) => (
        <div style={{ transform: "scale(1.1)" }}>{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getAllCalonNasabah(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      {/* ==========================================================================
          [BARU] MODAL: FORM EDIT NIK CALON NASABAH (FINTECH CORE STYLE)
          ========================================================================== */}
      <Modal
        size="md"
        show={modalEditNik}
        onHide={() => setModalEditNik(false)}
        centered
        contentClassName="border-0 shadow-lg"
        style={{
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(15, 23, 42, 0.15)",
        }}
      >
        {/* Garis Aksen Aksen Emas Perbankan Melayang */}
        <div
          style={{
            height: "6px",
            background: "linear-gradient(90deg, #2885c7 0%, #ffffff 100%)",
            borderRadius: "16px 16px 0 0",
          }}
        ></div>

        {/* Header Modal */}
        <Modal.Header
          closeButton
          className="border-0 pb-0 px-4 pt-4 bg-white"
          style={{ borderRadius: "16px 16px 0 0" }}
        >
          <div className="d-flex align-items-center">
            <div
              className="d-flex align-items-center justify-content-center mr-3 shadow-sm"
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "14px",
                backgroundColor: "rgba(40, 133, 199, 0.08)",
                color: "#2885c7",
                border: "1px solid rgba(40, 133, 199, 0.15)",
              }}
            >
              <i
                className="fas fa-fingerprint"
                style={{ fontSize: "18px" }}
              ></i>
            </div>
            <div>
              <Modal.Title
                className="h4 m-0 text-dark"
                style={{
                  fontWeight: "800",
                  letterSpacing: "-0.5px",
                  fontSize: "19px",
                }}
              >
                Koreksi NIK Nasabah
              </Modal.Title>
              <small
                className="text-muted font-weight-bold d-block mt-1"
                style={{ fontSize: "11.5px", lineHeight: "1.3" }}
              >
                Pastikan perubahan nomor identitas telah sesuai dengan berkas
                KTP fisik asli
              </small>
            </div>
          </div>
        </Modal.Header>

        {/* Isi Form Input Modal */}
        <Modal.Body className="p-4 bg-white">
          <Form onSubmit={(e) => e.preventDefault()}>
            <Form.Group className="mb-0">
              <label
                className="text-muted font-weight-bold mb-2"
                style={{
                  fontSize: "11px",
                  textTransform: "uppercase",
                  letterSpacing: "0.8px",
                  color: "#64748B",
                  display: "block",
                }}
              >
                Nomor Induk Kependudukan Baru
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Form.Control
                  type="text"
                  maxLength={16}
                  value={nik}
                  onChange={
                    handleNikChange
                  } /* Memakai fungsi hitung digit bawaan Anda */
                  placeholder="Masukkan 16 Digit NIK Koreksi"
                  style={{
                    height: "46px",
                    borderRadius: "12px",
                    borderColor: "#CBD5E1",
                    fontSize: "14px",
                    fontWeight: "600",
                    paddingRight: "85px",
                    color: "#1E293B",
                    boxShadow: "inset 0 2px 4px rgba(0,0,0,0.01)",
                  }}
                />
                {/* Indikator Sisa Digit Dinamis Realtime */}
                <div
                  style={{
                    position: "absolute",
                    right: "14px",
                    color: remainingDigits === 0 ? "#10B981" : "#94A3B8",
                    fontWeight: "700",
                    fontSize: "12.5px",
                    letterSpacing: "0.3px",
                  }}
                >
                  {remainingDigits} digit
                </div>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>

        {/* Panel Aksi Bawah */}
        <Modal.Footer
          className="border-0 px-4 pb-4 pt-0 bg-white d-flex justify-content-end align-items-center gap-2"
          style={{ borderRadius: "0 0 16px 16px" }}
        >
          <Button
            variant="link"
            className="text-muted font-weight-bold text-decoration-none mr-2 p-0"
            onClick={() => setModalEditNik(false)}
            style={{ fontSize: "13px", transition: "color 0.2s" }}
          >
            Batal
          </Button>
          <Button
            className="btn font-weight-bold px-4 py-2 border-0"
            style={{
              borderRadius: "10px",
              backgroundColor: "#2885c7",
              color: "#ffffff",
              fontSize: "13.5px",
              height: "40px",
              boxShadow: "0 4px 14px rgba(180,35,35,0.25)",
              transition: "all 0.2s",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#1c6ca0";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#2885c7";
              e.currentTarget.style.transform = "translateY(0)";
            }}
            onClick={submitUpdateNik} /* Eksekusi fungsi update database Anda */
          >
            Simpan NIK Baru
          </Button>
        </Modal.Footer>
      </Modal>

      {korcab.modalDetailNasabah ? (
        <Container fluid className="py-4">
          <Row>
            <Col md="12">
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: "20px" }}
              >
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h3
                        className="fw-800 text-dark m-0"
                        style={{ letterSpacing: "1px" }}
                      >
                        CALON NASABAH
                      </h3>
                      <p className="text-muted small mb-0">
                        Manajemen data prospek dan kunjungan calon nasabah baru.
                      </p>
                    </div>
                  </div>

                  {/* FILTER TOOLBAR */}
                  <div className="bg-light p-3 rounded-xl border-0 mt-3">
                    <Row className="align-items-center g-2">
                      <Col md={5} sm={12}>
                        <InputGroup className="bg-white rounded-lg border shadow-sm">
                          <InputGroup.Prepend>
                            <InputGroup.Text className="bg-transparent border-0 text-muted">
                              <i className="fas fa-search"></i>
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            className="border-0 bg-transparent"
                            style={{ height: "45px", boxShadow: "none" }}
                            type="text"
                            value={searchText}
                            onChange={handleSearch}
                            placeholder="Cari Nama / NIK / NIP..."
                            onKeyDown={handleKeyDown}
                          />
                          {searchText && (
                            <InputGroup.Append>
                              <InputGroup.Text
                                className="bg-transparent border-0 text-muted cursor-pointer"
                                onClick={handleClearSearch}
                              >
                                <i className="fas fa-times"></i>
                              </InputGroup.Text>
                            </InputGroup.Append>
                          )}
                        </InputGroup>
                      </Col>

                      <Col md="auto" sm={12} className="mt-2 mt-md-0">
                        <Button
                          variant="info"
                          className="px-4 fw-bold shadow-sm d-flex align-items-center text-white"
                          style={{
                            borderRadius: "10px",
                            height: "45px",
                            backgroundColor: "#00BFFF",
                            border: "none",
                          }}
                          onClick={handleFilterChange}
                        >
                          <i className="fas fa-sync-alt mr-2"></i> REFRES DATA
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Card.Header>

                <Card.Body className="px-4 pb-4">
                  {isLoading ? (
                    <div className="py-5 text-center d-flex flex-column align-items-center">
                      <l-quantum
                        size="55"
                        speed="2.75"
                        color="#00BFFF"
                      ></l-quantum>
                      <h5 className="mt-4 fw-600 text-muted animate-pulse">
                        Memuat Data Calon Nasabah...
                      </h5>
                    </div>
                  ) : (
                    <div className="table-responsive-custom">
                      <DataTable
                        columns={colKunjungan}
                        data={listDataCalonNasabah}
                        customStyles={customStyles}
                        pagination={false}
                        progressPending={isLoading}
                        highlightOnHover
                        pointerOnHover
                      />

                      {/* PAGINATION FOOTER */}
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-4 border-top">
                        <div className="d-flex align-items-center mb-3 mb-md-0">
                          <span className="text-muted small fw-bold mr-3">
                            Tampilkan
                          </span>
                          <div style={{ width: "120px" }}>
                            <Select
                              classNamePrefix="react-select"
                              value={options.find(
                                (opt) => opt.value === totalPerHalaman,
                              )}
                              onChange={handlePageSizeChange}
                              options={options}
                              menuPlacement="top"
                            />
                          </div>
                          <span className="text-muted small ml-3 d-none d-sm-inline">
                            data per halaman
                          </span>
                        </div>

                        <ReactPaginate
                          forcePage={page}
                          containerClassName="pagination mb-0"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          activeClassName="active"
                          disabledClassName="disabled"
                          pageCount={korcab.listCalonNasabah.totalPages || 1}
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={1}
                          nextLabel={<i className="fas fa-chevron-right"></i>}
                          previousLabel={
                            <i className="fas fa-chevron-left"></i>
                          }
                          onPageChange={(val) => setPage(val.selected)}
                        />
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <style>{`
    .fw-800 { font-weight: 800; }
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; }
    .rounded-lg { border-radius: 10px !important; }
    .cursor-pointer { cursor: pointer; }
    
    /* Animation */
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s infinite; }

    /* Custom Table Style */
    .rdt_Table { border: 1px solid #f1f5f9; border-radius: 12px; }
    
    /* Pagination yang kamu buat sebelumnya tetap dipakai di sini */
    .pagination { display: flex; list-style: none; padding: 0; gap: 5px; }
    .page-item.active .page-link { 
      background-color: #00BFFF !important; 
      border-color: #00BFFF !important; 
      color: white !important; 
    }
  `}</style>
        </Container>
      ) : (
        <>
          <GroupCalonNasabah data={idCalonNasabah} value={sendVal} />
        </>
      )}
    </>
  );
}

export default CalonNasabah;
